import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hotel-description-item" }
const _hoisted_2 = { class: "hotel-description-item__header" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]

import DescriptionItemIcon from './internals/DescriptionItemIcon.vue';

interface Props {
	title: string;
	text: string;
	icon: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelDescriptionItem',
  props: {
    title: {},
    text: {},
    icon: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DescriptionItemIcon, { icon: _ctx.icon }, null, 8 /* PROPS */, ["icon"]),
      _createElementVNode("h3", {
        class: "hotel-description-item__header-title",
        textContent: _toDisplayString(_ctx.title)
      }, null, 8 /* PROPS */, _hoisted_3)
    ]),
    _createElementVNode("p", {
      class: "hotel-description-item__text",
      textContent: _toDisplayString(_ctx.text)
    }, null, 8 /* PROPS */, _hoisted_4)
  ]))
}
}

})